import Address from './address'
import SellingMethod from './sellingMethod'
import WhatSellersSay from './whatSellersSay'
import WhySellersChooseAuction from './whySellersChooseAuction'
import Faq from './faq'
import FirstStep from './firstStep'
import { DynamicFieldProps } from '../../dynamicField'
import classNames from 'classnames/bind'
import styles from './styles.scss'
const cx = classNames.bind(styles)

const ConversationalFlowLandingPage = (props: DynamicFieldProps) => {
  return (
    <div className={cx('landing-sections-container')}>
      <Address {...props} />
      <SellingMethod />
      <WhySellersChooseAuction />
      <WhatSellersSay />
      <Faq />
      <FirstStep />
    </div>
  )
}

export default ConversationalFlowLandingPage
